import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=20b38316&scoped=true"
import script from "./ReportsView.ts?vue&type=script&lang=ts&external"
export * from "./ReportsView.ts?vue&type=script&lang=ts&external"
import style0 from "./ReportsView.scss?vue&type=style&index=0&id=20b38316&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b38316",
  null
  
)

export default component.exports